<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div>
    <!-- <ProjectListMenu /> -->
    <v-container grid-list-md>
      <v-btn round class="info ml-0 mb-4" @click="needAssistant">
        Need Assistance
        <v-icon class="ml-2">help</v-icon>
      </v-btn>
      <v-btn
        round
        class="warning ml-1 mb-4"
        @click="projectJourneyDialog = true"
      >
        <v-icon class="mr-2">timeline</v-icon>
        Project Journey
      </v-btn>
      
      <v-dialog v-model="projectJourneyDialog" width="550">
        <!-- <ProjectJourney /> -->
        <v-card>
          <img
            width="533"
            :src="require('../../assets/ProjectJourney.jpg')"
            alt="Project Journey"
          />
        </v-card>
      </v-dialog>
      <v-layout align-center justify-space-between row fill-height>
        <div class="d-flex">
          <h1 style="margin-right: 24px">Project List</h1>

          <v-dialog v-model="dialog" persistent max-width="600px">
            <need-assistant @click="onClickAssistant($event)" />
          </v-dialog>
          <v-snackbar
            v-model="snackbar"
            :right="x === 'right'"
            :timeout="timeout"
            color="success"
            :top="y === 'top'"
          >
            {{ errorMsg }}
            <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
          </v-snackbar>
        </div>
        <router-link to="/create-project">
          <v-btn round color="success" class="pa-4">
            <v-icon class="mr-2" style="font-size: 36px">add_circle</v-icon>
            Create a new Project
          </v-btn>
        </router-link>
      </v-layout>
      <!-- </v-container>
    <v-container> -->
      <v-card class="pa-3 mt-4">
        <v-layout row wrap>
          <v-flex sm5>
            <v-tabs
              slider-color="#f44336"
              v-model="tabs"
              @change="changeStatusId"
            >
              <v-tab
                v-for="item in items"
                :key="`item${item.id}`"
                :href="'#tab-' + item.id"
                v-if="item.id"
              >
                {{ item.title }} ({{
                  getCount(
                    projectStatusCount.find(
                      (status) => status.project_status_id === item.id
                    )
                  )
                }})
              </v-tab>
              <v-menu v-if="more.length" bottom class="" left>
                <template v-slot:activator="{ on }">
                  <a class="v-tabs__item custom-tab" v-on="on">
                    <span
                      v-if="!items[3].id"
                      style="margin-left: 60px; font-size: 14px"
                    >
                      More
                    </span>
                    <v-icon
                      color="#f44336"
                      style="font-weight: bold; font-size: 28px"
                      title="More"
                    >
                      arrow_drop_down
                    </v-icon>
                  </a>
                </template>
                <v-list class="grey lighten-3">
                  <v-list-tile
                    v-for="item in more"
                    :key="`itemm${item.id}`"
                    @click="addItem(item)"
                  >
                    {{ item.title }} ({{
                      getCount(
                        projectStatusCount.find(
                          (status) => status.project_status_id === item.id
                        )
                      )
                    }})
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-tabs>
          </v-flex>
          <v-flex sm7>
            <v-layout>
              <v-flex sm6 offset-sm1>
                <div>
                  <!-- <v-input>Date Range</v-input> -->
                  <Datepicker
                    range
                    v-model="selectedDate"
                    lang="en"
                    placeholder="Select Date Range"
                    @input="showDates"
                  />
                </div>
              </v-flex>
              <v-flex sm5>
                <div>
                  <v-text-field
                    v-model="search"
                    label="Search by Project Name"
                    @input="debounceSearch"
                    solo
                    clearable
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-tabs-items v-model="currentItem">
              <v-tab-item
                v-for="item in items"
                :key="item.id"
                :value="'tab-' + item.id"
                v-if="
                  currentItem === 'tab-' + item.id &&
                  (item.id === 8 || item.id === 1 || item.id === 13)
                "
              >
                <ProjectListContent
                  :statusId="statusId"
                  :searchText="searchText"
                  :startDate="convertDate(startDate)"
                  :endDate="convertDate(endDate)"
                />
              </v-tab-item>
              <v-tab-item
                v-for="item in more"
                :key="item.id"
                :value="'tab-' + item.id"
                v-if="currentItem === 'tab-' + item.id"
              >
                <ProjectListContent
                  :statusId="statusId"
                  :searchText="searchText"
                  :startDate="convertDate(startDate)"
                  :endDate="convertDate(endDate)"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>
<script>
  // import ProjectListMenu from "../../components/project/ProjectListMenu";
  import ProjectListContent from "../../components/project/ProjectListContent";
  import "vue-datepicker-ui/lib/vuedatepickerui.css";
  import VueDatepickerUi from "vue-datepicker-ui";
  import { debounce } from "lodash";
  import { NeedAssistant } from "@/components/index";
  import { mapGetters } from "vuex";
  // import ProjectJourney from "../../components/project/ProjectJourney";
  export default {
    components: {
      // ProjectListMenu,
      ProjectListContent,
      Datepicker: VueDatepickerUi,
      NeedAssistant,
      // ProjectJourney,
    },

    data() {
      return {
        currentItem: "tab-1",
        tabs: null,
        items: [
          { id: 8, title: "Live" },
          { id: 1, title: "Draft" },
          { id: 13, title: "Completed" },
          {},
        ],
        more: [
          { id: 2, title: "Pending" },
          { id: 3, title: "Rejected" },
          { id: 5, title: "Verified" },
          { id: 4, title: "Require Modification" },
          { id: 7, title: "Schedule" },
          { id: 9, title: "Cancel" },
          { id: 10, title: "On Hold" },
          { id: 11, title: "Pause" },
        ],
        dialog: false,
        projectJourneyDialog: false,

        selectedMore: "More",
        search: "",
        searchText: "",
        statusId: 8,
        selectedDate: [null, null],
        startDate: "",
        endDate: "",
        snackbar: false,
        y: "bottom",
        x: "right",
        timeout: 4000,
      };
    },
    computed: {
      ...mapGetters(["projectStatusCount", "error", "statusCode", "errorMsg"]),
    },
    created() {
      this.initialize();
    },
    methods: {
      initialize() {
        this.$store.dispatch("projectStatusCount", ["project-status-count"]);
      },
      addItem(item) {
        // const removed = this.items.splice(0, 1);
        this.items[3] = item;
        // this.more.push(...removed);
        this.$nextTick(() => {
          this.currentItem = "tab-" + item.id;
        });
        this.selectedMore = item.title;
        this.tabs = "tab-" + item.id;
        this.changeStatusId();
      },
      changeStatusId() {
        this.currentItem = this.tabs;
        this.statusId = this.tabs.split("tab-")[1];
      },
      debounceSearch: debounce(function () {
        // Debounce the search method with a delay of 500ms
        // Perform the search with the current search text
        this.searchText = this.search;
      }, 500),
      convertDate(date) {
        if (!date) return "";
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        return date
          .toLocaleDateString("en-CA", options)
          .split("/")
          .reverse()
          .join("-");
      },
      showDates(dates) {
        if (dates[0] & dates[1]) {
          this.startDate = dates[0];
          this.endDate = dates[1];
        }
      },
      needAssistant() {
        this.dialog = true;
        // this.snackbar = true;
        // this.close();
      },
      onClickAssistant(event) {
        if (event == 1) {
          this.dialog = false;
          this.snackbar = true;
          this.close;
        } else {
          this.dialog = false;
        }
      },
      getStepIcon(index) {
        if (index <= this.activeStep) {
          return "mdi-check";
        } else {
          return "mdi-circle-outline";
        }
      },
      getCount(data) {
        if (data) {
          return data.count;
        }
        return 0;
      },
    },
  };
</script>
<style scoped>
  .border-2 {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 2px 0 2px 13px !important;
    align-items: stretch;
    min-height: 44px;
    margin-top: 2px;
  }
  .border-2 .v-input {
    position: relative;
    top: 12px;
    color: rgba(0, 0, 0, 0.6) !important;
    font-size: 14px;
  }
  .custom-tab {
    font-size: 16px;
    max-width: 0 !important;
  }
  .searchField {
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 0;
  }
  .no-line
    .theme--light.v-text-field
    > .v-input__control
    > .v-input__slot:before {
    border: none !important;
  }
  .v-calendar .input-field input {
    border: 4px solid rgba(0, 0, 0, 0.9) !important;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  }
  .step {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: 500;
  }

  .step-circle {
    border-left: 3px dashed #f44336;
    width: 0;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ::v-deep .v-dialog {
    max-height: 95%;
  }
</style>
